import { Injectable } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {finalize} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {

  constructor(private spinner: NgxSpinnerService) { }

  /**
   * Intercepts an HTTP request and handles it while showing a loader.
   *
   * @param req The HTTP request to be intercepted
   * @param next The HTTP handler for the request
   * @return An Observable of the HTTP event with loader handling
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Skip spinner for background requests (e.g. autocomplete search)
    // to avoid DOM manipulation that interrupts mobile keyboard input.
    if (req.headers.has('X-Skip-Spinner')) {
      const cleanReq = req.clone({
        headers: req.headers.delete('X-Skip-Spinner')
      });
      return next.handle(cleanReq);
    }

    // Show loader when HTTP request is made
    this.spinner.show();

    // Intercept and handle the HTTP request
    return next.handle(req).pipe(
      finalize(() => {
        // Hide loader when HTTP request is complete (success or error)
        this.spinner.hide();
      })
    );
  }
}
